import { CmsMemory } from '../../src/integrations/contentful/types';
import cmsTravelPhase from './cmsTravelPhase';
import { festivalImage } from './cmsImages';
import { lisbonTrip, lofotenTrip } from './cmsTrip';
import cmsHotelPhase from './cmsHotelPhase';
import cmsExperiencePhase from './cmsExperiencePhase';
import { jussiTraveller, saraTraveller } from './cmsTraveller';
import { lisbon } from './cmsDestinations';

const lisbonMemory = {
  sys: {
    space: {
      sys: {
        type: 'Link',
        linkType: 'Space',
        id: 'bh7k0sgo84rb'
      }
    },
    id: '5GD0bE1kcOKNj2KUTiegGY',
    type: 'Entry',
    createdAt: '2019-08-21T13:58:06.641Z',
    updatedAt: '2019-08-22T09:57:39.524Z',
    environment: {
      sys: {
        id: 'master',
        type: 'Link',
        linkType: 'Environment'
      }
    },
    revision: 2,
    contentType: {
      sys: {
        type: 'Link',
        linkType: 'ContentType',
        id: 'memory'
      }
    },
    locale: 'fi-FI'
  },
  fields: {
    title: 'Nos-festareilla Lissabonissa',
    subtitle: 'Lissabonin kaupunkiloma festaritunnelmissa.',
    slug: 'nos-festareilla-lissabonissa',
    seoTitle: 'Matka Nos-festareille Lissabonissa',
    leadParagraph:
      'NOS-festareiden ympärille rakentuva matka keväiseen Lissaboniin on juuri sitä millä jaksaa kesälomiin asti. Erityiskiitoksen festareilla ansaitsee visuaalinen tapahtumatuotanto: kameran rulla täyttyi vauhdilla.\n',
    seoDescription:
      'Tutustu muistoon NOS-festareiden ympärille rakentuva matka keväiseen Lissaboniin on juuri sitä millä jaksaa kesälomiin asti. Erityiskiitoksen festareilla ansaitsee visuaalinen tapahtumatuotanto: kameran rulla täyttyi vauhdilla.',
    trip: lisbonTrip,
    mainImage: festivalImage,
    startDate: '2018-06-11',
    endDate: '2018-06-16',
    matkanKesto: '5 yötä',
    golfInfo: '3 kierrosta eri kentillä',
    tripDepartures: 'Lennot lauantaisin',
    vehicleInfo: 'Bussikuljetukset sisältyvät',
    travellers: [jussiTraveller],
    destinations: [lisbon],
    phases: [
      cmsTravelPhase,
      cmsHotelPhase,
      cmsExperiencePhase,
      {
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'bh7k0sgo84rb'
            }
          },
          id: '226wOqCSPRjA9CzLmFyljX',
          type: 'Entry',
          createdAt: '2019-08-21T13:58:14.623Z',
          updatedAt: '2019-08-21T13:58:14.624Z',
          environment: {
            sys: {
              id: 'master',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: 'Link',
              linkType: 'ContentType',
              id: 'experiencePhase'
            }
          },
          locale: 'fi-FI'
        },
        fields: {
          label: 'Casal Sta. Maria, viinitilavierailu',
          title: 'Viini on hyvää!',
          mainMedia: {
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'bh7k0sgo84rb'
                }
              },
              id: '4sDsfLPjNyueHbM1xGKx4K',
              type: 'Asset',
              createdAt: '2019-08-21T13:53:55.139Z',
              updatedAt: '2019-08-21T13:53:55.139Z',
              environment: {
                sys: {
                  id: 'master',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              revision: 1,
              locale: 'fi-FI'
            },
            fields: {
              title: 'Rypäleet',
              description: 'Rypäleitä messissä!',
              file: {
                url: '//localhost:3000/static/test/dummy-image.png',
                details: {
                  size: 3460837,
                  image: {
                    width: 1560,
                    height: 1512
                  }
                },
                fileName: 'Screenshot 2019-08-21 at 16.39.34.png',
                contentType: 'image/png'
              }
            }
          },
          leadParagraph:
            'Viinitilavierailu 30 kilsan päähän Lissabonista länteen festareiden jälkeisenä sunnuntaina. Vaikka päivä oli kuuma Atlantin tuuli viilensi kivasti ja muutama pullo Arintoa tarttui kotiinviemisiksi.',
          content:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam non\nauctor dui. Nunc condimentum nibh sed ornare molestie. Curabitur id\nlibero sit amet ante porttitor ultrices. In id lacus posuere, accumsan\nlorem in, blandit lorem. Suspendisse justo nisl, bibendum vitae\nporttitor at, accumsan ut augue.\n\nSuspendisse tincidunt mi sed magna rutrum vulputate. Duis\npellentesque euismod magna non vestibulum. Fusce posuere facilisis\nmetus, ac laoreet tellus. Vestibulum eu dolor sed odio commodo\nmalesuada. Pellentesque accumsan tincidunt tincidunt. Nullam luctus\naliquet malesuada. Curabitur gravida ex non rutrum efficitur.',
          media: [
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '2YUPyxp0Ny6GMMpcTpLQWJ',
                type: 'Asset',
                createdAt: '2019-08-21T13:54:45.083Z',
                updatedAt: '2019-08-21T13:54:45.083Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                locale: 'fi-FI'
              },
              fields: {
                title: 'Valkkarii',
                description: 'Valkkari oli tosi hyvää!',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 1957801,
                    image: {
                      width: 1680,
                      height: 768
                    }
                  },
                  fileName: 'Screenshot 2019-08-21 at 16.39.40.png',
                  contentType: 'image/png'
                }
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '116i2piSxqx0bp9Vq9a6Wn',
                type: 'Asset',
                createdAt: '2019-08-21T13:56:05.580Z',
                updatedAt: '2019-08-21T13:56:05.580Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                locale: 'fi-FI'
              },
              fields: {
                title: 'Kippis',
                description: 'Kippiskuppis!',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 1707575,
                    image: {
                      width: 1686,
                      height: 770
                    }
                  },
                  fileName: 'Screenshot 2019-08-21 at 16.39.45.png',
                  contentType: 'image/png'
                }
              }
            }
          ],
          ctaText: 'Tutustu',
          ctaUrl: 'https://casalstamaria.pt/'
        }
      },
      {
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'bh7k0sgo84rb'
            }
          },
          id: '2VtrWXX3whLNz1OFN4IJMO',
          type: 'Entry',
          createdAt: '2019-08-21T13:58:14.619Z',
          updatedAt: '2019-08-21T13:58:14.619Z',
          environment: {
            sys: {
              id: 'master',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: 'Link',
              linkType: 'ContentType',
              id: 'travelPhase'
            }
          },
          locale: 'fi-FI'
        },
        fields: {
          label: 'Lissabon → Helsinki, Finnair',
          title: 'Kotimatkalla otettiin rennosti',
          mainMedia: {
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'bh7k0sgo84rb'
                }
              },
              id: '7hISU26zAtPVFTBEaznsek',
              type: 'Asset',
              createdAt: '2019-08-21T13:57:15.054Z',
              updatedAt: '2019-08-21T13:57:15.054Z',
              environment: {
                sys: {
                  id: 'master',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              revision: 1,
              locale: 'fi-FI'
            },
            fields: {
              title: 'Lentokone',
              description: 'Mä niin rakastan auringonlaskuja!!!',
              file: {
                url: '//localhost:3000/static/test/dummy-image.png',
                details: {
                  size: 2505966,
                  image: {
                    width: 2596,
                    height: 1224
                  }
                },
                fileName: 'Screenshot 2019-08-21 at 16.40.23.png',
                contentType: 'image/png'
              }
            }
          },
          media: [],
          leadParagraph:
            'Illaksi kotiin sinisillä siivillä. Portelan lentoasemalla on kohtuulliset ostosmahdollisuudet, mutta suosittelen kuitenkin hankkimaan tuliaset jo matkan varrelta.',
          ctaText: 'Näytä lennot',
          ctaDescription: 'Lissabon → Helsinki, Finnair',
          ctaUrl: 'https://www.finnair.fi/'
        }
      }
    ],
    groups: ['couple', 'family', 'friends', 'single'],
    activities: ['escape', 'party', 'chill', 'learn'],
    lengths: ['week', 'verylong']
  }
};

const tenerifeMemory = {
  sys: {
    space: {
      sys: {
        type: 'Link',
        linkType: 'Space',
        id: 'bh7k0sgo84rb'
      }
    },
    id: '75IA0woIxNHMmmJZEWWtw7',
    type: 'Entry',
    createdAt: '2020-03-24T10:52:37.230Z',
    updatedAt: '2020-03-24T10:52:37.230Z',
    environment: {
      sys: {
        id: 'sandbox1',
        type: 'Link',
        linkType: 'Environment'
      }
    },
    revision: 1,
    contentType: {
      sys: {
        type: 'Link',
        linkType: 'ContentType',
        id: 'memory'
      }
    },
    locale: 'fi-FI'
  },
  fields: {
    title: 'Retkeilijän ja herkuttelijan aurinkoinen Teneriffa',
    subtitle: 'Nauti auringosta ja herkuista Teneriffalla.',
    slug: 'retkeilijan-ja-herkuttelijan-aurinkoinen-teneriffa',
    seoTitle: 'Retkeilijän ja herkuttelijan aurinkoinen Teneriffa',
    seoDescription: 'Teneriffa on lomien klassikko',
    leadParagraph:
      'Mielikuvieni Kanaria oli suomalaisia karaokeravintoloita, lihapullabaareja ja turistien laumoja, joiden vetovoimaisuus ei valitettavasti minuun iskenyt. Vuodenvaihde matkustusajankohtana pakotti kuitenkin antamaan Kanarialle mahdollisuuden. Kohtalaisen pituinen lentomatka ja aurinkotakuu talven keskellä veivät meidät Teneriffan suositulle saarelle. Jo etukäteen asiaan paremmin tutustuttuani totesin, että saarelta tulisi varmasti löytymään paljon muutakin kuin turistikyliä ja hotellialueita. Teneriffan upea luonto, herkullinen ruoka ja ystävälliset ihmiset antoivat parastaan ja matkasta tuli mitä mainioin!',

    trip: lofotenTrip,
    mainImage: festivalImage,
    startDate: '2019-12-31',
    endDate: '2020-01-07',
    matkanKesto: '7 yötä',
    golfInfo: '5 kierrosta (Abama, Adeje)',
    tripDepartures: 'Lähdöt tiistaisin',
    vehicleInfo: 'Vuokra-auto sisältyy',
    travellers: [saraTraveller],
    phases: [
      {
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'bh7k0sgo84rb'
            }
          },
          id: '6mpOYmKXj1zyd4amSYkrmA',
          type: 'Entry',
          createdAt: '2020-03-24T10:01:06.629Z',
          updatedAt: '2020-03-24T10:01:06.629Z',
          environment: {
            sys: {
              id: 'sandbox1',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: 'Link',
              linkType: 'ContentType',
              id: 'travelPhase'
            }
          },
          locale: 'fi-FI'
        },
        fields: {
          label: 'Helsinki–Teneriffa',
          title: 'Loma alkakoon!',
          mainMedia: {
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'bh7k0sgo84rb'
                }
              },
              id: '4Lfz36924f1gh7Q5hpPZTl',
              type: 'Asset',
              createdAt: '2020-03-24T10:00:35.595Z',
              updatedAt: '2020-03-24T10:00:35.595Z',
              environment: {
                sys: {
                  id: 'sandbox1',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              revision: 1,
              locale: 'fi-FI'
            },
            fields: {
              title: 'teneriffa-espanja-001',
              description:
                'Joko ollaan perillä? Malttamattomat matkaajat kuluttavat aikaa lentokoneessa.',
              file: {
                url: '//localhost:3000/static/test/dummy-image.png',
                details: {
                  size: 102687,
                  image: {
                    width: 690,
                    height: 920
                  }
                },
                fileName: 'teneriffa-espanja-001.jpg',
                contentType: 'image/jpeg'
              }
            }
          },
          content:
            'Kiireisen ja pimeän syksyn jälkeen oli viimein koittanut odotettu hetki: lähdimme uudenvuodenaattona perheemme kanssa Helsingistä kohti Kanariansaaria ja Teneriffaa. Aikainen aamulento sujui jännittyneissä ja innostuneissa tunnelmissa, mutta silti unikin maittoi lyhyeksi jääneiden yöunien jälkeen. Heti Teneriffan eteläisellä lentokentällä aurinko ja lämpö ottivat meidät vastaan ja loma oli valmis alkamaan! '
        }
      },
      {
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'bh7k0sgo84rb'
            }
          },
          id: 'dsfcsHS2GutpFLOqw4S4T',
          type: 'Entry',
          createdAt: '2020-03-24T10:05:12.450Z',
          updatedAt: '2020-03-24T10:05:12.450Z',
          environment: {
            sys: {
              id: 'sandbox1',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: 'Link',
              linkType: 'ContentType',
              id: 'hotelPhase'
            }
          },
          locale: 'fi-FI'
        },
        fields: {
          label: 'Gran Oasis Resort',
          title: 'Viimein perillä hotellilla - ja altaalla!',
          mainMedia: {
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'bh7k0sgo84rb'
                }
              },
              id: '4K7PLuxOc7cyzc2ffoik7C',
              type: 'Asset',
              createdAt: '2020-03-24T10:04:10.475Z',
              updatedAt: '2020-03-24T10:04:10.475Z',
              environment: {
                sys: {
                  id: 'sandbox1',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              revision: 1,
              locale: 'fi-FI'
            },
            fields: {
              title: 'teneriffa-espanja-002',
              description:
                'Upea auringonlasku hotellilla vei todelliseen lomatunnelmaan.\n',
              file: {
                url: '//localhost:3000/static/test/dummy-image.png',
                details: {
                  size: 90073,
                  image: {
                    width: 690,
                    height: 920
                  }
                },
                fileName: 'teneriffa-espanja-002.jpg',
                contentType: 'image/jpeg'
              }
            }
          },
          content:
            'Suuntasimme kohti hotelliamme, joka sijaitsi Los Cristianoksen ja Playa de las Americasin läheisyydessä. Matka lentokentältä hotellille kesti noin parikymmentä minuuttia. Hotellimme Gran Oasis Resort sijaitsi hieman korkeammalla rinteillä, joten huoneemme kahdelta parvekkeelta pystyi ihailemaan merimaisemaa palmujen huojuessa lämpimässä tuulessa. Hotellin sijainti golfkenttien läheisyydessä oli oivallinen lapsiperheen näkökulmasta, koska lähellä ei ollut vilkasta liikennettä eikä yökerhoja tai muuta meteliä. \n\nLapset olivat malttamattomina odottaneet uimista lämmitetyissä uima-altaissa, joten ensimmäiseksi meidän oli suunnattava testaamaan hotellin altaat. Kolme erilaista allasta kolmessa eri tasossa ja lämmin +27 asteinen vesi vakuuttivat koko porukan uimarit!',
          media: [
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '51bacgPFC0mHtheX4qJLHb',
                type: 'Asset',
                createdAt: '2020-03-24T10:04:55.711Z',
                updatedAt: '2020-03-24T10:04:55.711Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                locale: 'fi-FI'
              },
              fields: {
                title: 'teneriffa-espanja-003',
                description: 'Vesipeto testaamassa hotellin uima-altaan tasoa.',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 221956,
                    image: {
                      width: 690,
                      height: 920
                    }
                  },
                  fileName: 'teneriffa-espanja-003.jpg',
                  contentType: 'image/jpeg'
                }
              }
            }
          ]
        }
      },
      {
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'bh7k0sgo84rb'
            }
          },
          id: '5UkMo3DLS0IKS1sJVxLlJk',
          type: 'Entry',
          createdAt: '2020-03-24T10:13:07.135Z',
          updatedAt: '2020-03-24T10:13:07.135Z',
          environment: {
            sys: {
              id: 'sandbox1',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: 'Link',
              linkType: 'ContentType',
              id: 'experiencePhase'
            }
          },
          locale: 'fi-FI'
        },
        fields: {
          label: 'South West Hill',
          title: 'Retki näköalapaikalle',
          mainMedia: {
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'bh7k0sgo84rb'
                }
              },
              id: '6Lsh9lVBCE9Q2dhg4HDmLp',
              type: 'Asset',
              createdAt: '2020-03-24T10:07:40.617Z',
              updatedAt: '2020-03-24T10:07:40.617Z',
              environment: {
                sys: {
                  id: 'sandbox1',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              revision: 1,
              locale: 'fi-FI'
            },
            fields: {
              title: 'teneriffa-espanja-004',
              description:
                'Polku ei johtanutkaan suoraan näköalapaikalle, vaan piti jatkaa vielä matkaa jyrkänteen reunaa kohti.',
              file: {
                url: '//localhost:3000/static/test/dummy-image.png',
                details: {
                  size: 208115,
                  image: {
                    width: 1227,
                    height: 920
                  }
                },
                fileName: 'teneriffa-espanja-004.jpg',
                contentType: 'image/jpeg'
              }
            }
          },
          content:
            'Matkan kolmantena päivänä lähdimme kävelyretkelle Los Cristianoksen kaakkoispuolella sijaitsevalle korkealle näköalapaikalle South West Hillille. Kiipesimme jyrkkää kivikkoista rinnettä ylös hyvin merkittyä polkua pitkin hienojen maisemien toivossa. Rinteessä ja ylhäällä vuorella kasvoi tyräkkejä, kaktuksia ja muita paikallisia kasveja, joita ei kylässä päässyt ihailemaan. Ylhäälle päästyämme tuuli puhalsi navakasti ja meri ei auennutkaan edessämme, kuten olimme kuvitelleet. \n\nJatkoimme kävelyä jyrkkää rantatörmää kohden ja vihdoin edessämme avautui maisema merelle La Gomeran suuntaan ja Los Cristianoksen kylään päin. Jyrkänteen alapuolella näkyivät kalankasvatusaltaat, joiden luo pääsimmekin myöhemmin tutustumaan tarkemmin. Reitti ylös oli lyhyt mutta aika raskas, koska korkeuseroa oli jonkin verran.  Nelivuotiaskin jaksoi kuitenkin hienosti kiivetä ja hyppiä kivikossa koko matkan ylös. Kiipeäminen oli kaiken vaivan arvoista, sillä maisemat ylhäällä olivat upeita!',
          media: [
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '5yrPQOgo30wLEVlvmQ6Mt9',
                type: 'Asset',
                createdAt: '2020-03-24T10:08:49.150Z',
                updatedAt: '2020-03-24T10:08:49.150Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                locale: 'fi-FI'
              },
              fields: {
                title: 'teneriffa-espanja-005',
                description:
                  'Maisema Los Cristianoksen suuntaan aukesi ylhäältä.',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 360440,
                    image: {
                      width: 1227,
                      height: 920
                    }
                  },
                  fileName: 'teneriffa-espanja-005.jpg',
                  contentType: 'image/jpeg'
                }
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '2Vrvs8ZXkaiKa61LFWYCiK',
                type: 'Asset',
                createdAt: '2020-03-24T10:12:55.035Z',
                updatedAt: '2020-03-24T10:12:55.035Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                locale: 'fi-FI'
              },
              fields: {
                title: 'teneriffa-espanja-007',
                description:
                  'Luonto on Teneriffan eteläosissa hyvin kuivaa ja karua.',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 223288,
                    image: {
                      width: 690,
                      height: 920
                    }
                  },
                  fileName: 'teneriffa-espanja-007.jpg',
                  contentType: 'image/jpeg'
                }
              }
            }
          ]
        }
      },
      {
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'bh7k0sgo84rb'
            }
          },
          id: '6quM8JSKB6lwRb2yugHRLj',
          type: 'Entry',
          createdAt: '2020-03-24T10:19:43.988Z',
          updatedAt: '2020-03-24T10:19:43.988Z',
          environment: {
            sys: {
              id: 'sandbox1',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: 'Link',
              linkType: 'ContentType',
              id: 'experiencePhase'
            }
          },
          locale: 'fi-FI'
        },
        fields: {
          label: 'Teiden kansallispuisto',
          title: 'Auto alle ja tulivuorta valloittamaan',
          mainMedia: {
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'bh7k0sgo84rb'
                }
              },
              id: '3jye3Y3Om703Vzf6WzMBKO',
              type: 'Asset',
              createdAt: '2020-03-24T10:15:34.616Z',
              updatedAt: '2020-03-24T10:15:34.616Z',
              environment: {
                sys: {
                  id: 'sandbox1',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              revision: 1,
              locale: 'fi-FI'
            },
            fields: {
              title: 'teneriffa-espanja-008',
              description:
                'El Teiden valkoinen huippu, joka kohoaa yli 3 700 metrin korkeuteen.',
              file: {
                url: '//localhost:3000/static/test/dummy-image.png',
                details: {
                  size: 249034,
                  image: {
                    width: 1227,
                    height: 920
                  }
                },
                fileName: 'teneriffa-espanja-008.jpg',
                contentType: 'image/jpeg'
              }
            }
          },
          content:
            'Loman puolivälissä vuokrasimme auton kahdeksi päiväksi päästäksemme tarkemmin tutustumaan Teneriffan upeaan ja vaihtelevaan luontoon. Ensimmäisenä päivänä suuntasimme kohti Teiden kansallispuistoa. Ajelimme hyvässä kunnossa olevia asfaltoituja teitä rannikkoa pitkin ensin puolisen tuntia, jonka jälkeen lähdimme nousemaan ylös vuoren rinnettä. Pian edessämme avautui kanarianmäntymetsiä, joiden vihreys lumosi hohkakivimaisemien jälkeen suomalaisessa luonnossa kasvaneet matkaajat. Oli upeaa nähdä, että saarella on myös vihreyttä kaiken kuivuuden lisäksi.\n\nPian alkoivat metsätkin loppua ja lämpötila laski kovaa vauhtia rannikon +25 asteesta lähelle kymmentä astetta. Aurinko kuitenkin paistoi kirkkaalta taivaalta, joten tuskin tulisimme palelemaan ylhäällä vuorellakaan. Maisemat muuttuivat yhä enemmän laavakiven muovaamiksi, ja kun pääsimme suuren kalderan sisälle, tuntui kuin olisimme tulleet kuuhun! Pian saavuimmekin jo parkkipaikalle, josta meidän oli tarkoitus ihailla El Teiden huippua ja lähteä tekemään lyhyttä retkeä.\n\nOlimme valinneet reitiksi kuuluisan Roques de Garcian läheisyydessä kiertävän ympyräreitin, jonka pituus oli muutama kilometri. Pian kuitenkin huomasimme, että reitti olikin paljon vaativampi kuin olimme ajatelleet. Onneksi meillä oli hyvät eväät mukana, pidimme vähän pidemmän evästauon ja keräsimme voimia kierroksen loppua varten. \n\nUpeat maisemat ja auringonpaiste hellivät meitä. Kuitenkin viimeinen nousu takaisin lähtöpisteelle ja auton luo meinasi olla monelle meistä hieman liikaa. Kun “Jumalan sormi” jälleen pilkisti vuoren rinteen takaa, tiesimme olevamme viimein perillä. Mahtava kokemus, vaikkakin hieman rankka kahden pienen lapsen kanssa!',
          media: [
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '3bGfce5Ef7ktjaboChVu3X',
                type: 'Asset',
                createdAt: '2020-03-24T10:16:41.833Z',
                updatedAt: '2020-03-24T10:16:41.833Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                locale: 'fi-FI'
              },
              fields: {
                title: 'teneriffa-espanja-009',
                description: 'Energiatankkaus ennen retkeä laavakivimaisemiin.',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 211969,
                    image: {
                      width: 690,
                      height: 920
                    }
                  },
                  fileName: 'teneriffa-espanja-009.jpg',
                  contentType: 'image/jpeg'
                }
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '4QGpFuOkDg5QqFlgzYySmN',
                type: 'Asset',
                createdAt: '2020-03-24T10:18:03.877Z',
                updatedAt: '2020-03-24T10:18:03.877Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                locale: 'fi-FI'
              },
              fields: {
                title: 'teneriffa-espanja-010',
                description:
                  'Reitin korkeuserot eivät aivan olleet tiedossamme etukäteen, mutta maisemien jylhyys ja erikoisuus sai jaksamaan yhä eteenpäin.',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 498800,
                    image: {
                      width: 1227,
                      height: 920
                    }
                  },
                  fileName: 'teneriffa-espanja-010.jpg',
                  contentType: 'image/jpeg'
                }
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '2lu5sfQ5B8VWaXgQgf5CT8',
                type: 'Asset',
                createdAt: '2020-03-24T10:19:36.428Z',
                updatedAt: '2020-03-24T10:19:36.428Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                locale: 'fi-FI'
              },
              fields: {
                title: 'teneriffa-espanja-011',
                description:
                  'Roque Cinchado – Jumalan sormeksi kutsuttu kivimuodostelma.',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 161985,
                    image: {
                      width: 690,
                      height: 920
                    }
                  },
                  fileName: 'teneriffa-espanja-011.jpg',
                  contentType: 'image/jpeg'
                }
              }
            }
          ]
        }
      },
      {
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'bh7k0sgo84rb'
            }
          },
          id: '1kEvFEbpBKuuE9zVsiqNHN',
          type: 'Entry',
          createdAt: '2020-03-24T10:23:42.885Z',
          updatedAt: '2020-03-24T10:23:42.885Z',
          environment: {
            sys: {
              id: 'sandbox1',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: 'Link',
              linkType: 'ContentType',
              id: 'experiencePhase'
            }
          },
          locale: 'fi-FI'
        },
        fields: {
          label: 'La Caleta',
          title: 'Herkuttelua kalastajakylässä',
          mainMedia: {
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'bh7k0sgo84rb'
                }
              },
              id: '3QcEUQuryJ9RZgBOqTZbUx',
              type: 'Asset',
              createdAt: '2020-03-24T10:21:33.251Z',
              updatedAt: '2020-03-24T10:21:33.251Z',
              environment: {
                sys: {
                  id: 'sandbox1',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              revision: 1,
              locale: 'fi-FI'
            },
            fields: {
              title: 'teneriffa-espanja-012',
              description: 'Herkuttelua Celso Restaurantessa.',
              file: {
                url: '//localhost:3000/static/test/dummy-image.png',
                details: {
                  size: 126972,
                  image: {
                    width: 690,
                    height: 920
                  }
                },
                fileName: 'teneriffa-espanja-012.jpg',
                contentType: 'image/jpeg'
              }
            }
          },
          content:
            'Teiden reissun jälkeen oli aika rentoutua paikallisessa kylässä herkullisilla merenantimilla. La Caletan kylässä voi aistia aitoa teneriffalaista kalastajakylän henkeä. Rantabulevardi on reunustettu tunnelmallisilla ravintoloilla, joista on upeat näköalat merelle La Gomeran suuntaan. Kylän rannalla pikaisen pulahduksen ja rapujen tarkkailun jälkeen valikoimme ravintolaksi Celso Restauranten, jossa oli iso terassi rantakadulla merinäköalalla.\n\nListalla oli paljon mereneläviä ja kalaa eri muodoissa. Mojo rojo, mojo verde ja ryppyiset kanarianperunat kruunasivat ateriat. Herkulliset annokset upposivat retkiseurueeseen hetkessä. Ruokailun jälkeen oli aika suunnata takaisin hotellille lepäämään. La Caletan viihtyisään ja tunnelmalliseen kylään aiomme vielä joskus palata!',
          media: [
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '7gyYUAqxxAs0M8k0qSi9DJ',
                type: 'Asset',
                createdAt: '2020-03-24T10:22:38.192Z',
                updatedAt: '2020-03-24T10:22:38.192Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                locale: 'fi-FI'
              },
              fields: {
                title: 'teneriffa-espanja-013',
                description:
                  'Uunissa haudutettu kala peruna- ja kasvispedillä maistui nälkäisille.',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 180056,
                    image: {
                      width: 690,
                      height: 920
                    }
                  },
                  fileName: 'teneriffa-espanja-013.jpg',
                  contentType: 'image/jpeg'
                }
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '4ckV5mfOXJ0KQI08Q4sIN7',
                type: 'Asset',
                createdAt: '2020-03-24T10:23:35.840Z',
                updatedAt: '2020-03-24T10:23:35.840Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                locale: 'fi-FI'
              },
              fields: {
                title: 'teneriffa-espanja-014',
                description:
                  'Varpaiden kastelua meressä rankan retken jälkeen.',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 322555,
                    image: {
                      width: 690,
                      height: 920
                    }
                  },
                  fileName: 'teneriffa-espanja-014.jpg',
                  contentType: 'image/jpeg'
                }
              }
            }
          ]
        }
      },
      {
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'bh7k0sgo84rb'
            }
          },
          id: '2KTA1Y2csBYrmCGu8i9QV9',
          type: 'Entry',
          createdAt: '2020-03-24T10:29:55.457Z',
          updatedAt: '2020-03-24T10:29:55.457Z',
          environment: {
            sys: {
              id: 'sandbox1',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: 'Link',
              linkType: 'ContentType',
              id: 'experiencePhase'
            }
          },
          locale: 'fi-FI'
        },
        fields: {
          label: 'Anagan luonnonpuisto',
          title: 'Päiväretki laakeripuumetsissä',
          mainMedia: {
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'bh7k0sgo84rb'
                }
              },
              id: '38X18xUjr5zLpEw7XPF2fe',
              type: 'Asset',
              createdAt: '2020-03-24T10:25:23.804Z',
              updatedAt: '2020-03-24T10:25:23.804Z',
              environment: {
                sys: {
                  id: 'sandbox1',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              revision: 1,
              locale: 'fi-FI'
            },
            fields: {
              title: 'teneriffa-espanja-015',
              description:
                'Polkua reunustavat puut loivat tunnelin, jonka sisällä metsässä oli taianomaista kävellä.\n',
              file: {
                url: '//localhost:3000/static/test/dummy-image.png',
                details: {
                  size: 286506,
                  image: {
                    width: 690,
                    height: 920
                  }
                },
                fileName: 'teneriffa-espanja-015.jpg',
                contentType: 'image/jpeg'
              }
            }
          },
          content:
            'Toisena autollisena päivänä suuntasimme moottoritietä kohti saaren koilliskärkeä ohi pääkaupunki Santa Cruzin. Päästyämme Santa Cruzin ohi ylös vuorille päin maisema muuttui silmissämme toisenlaiseksi. Oli kuin olisimme saapuneet aivan eri saarelle, sillä vehreys avautui silmiemme edessä. Saaren koillis- ja pohjoisosat ovatkin tunnettuja vihreydestään verrattuna etelän kuivaan ja karuun maisemaan. \n\nSuuntasimme ylös Anagan vuoristoon ja kohti alueen luonnonpuiston opastuskeskusta. Tie ylös vuoristoon oli kuin serpentiiniä: mutkainen ja kapea. Tien yllä puiden oksat loivat tunneleita, joiden läpi ajoimme sadunomaisissa tunnelmissa.\n\nTarkoituksenamme oli käydä pienellä kävelyretkellä alueen sademetsissä. Anagan alue tunnetaan subtrooppisista laakeripuumetsistä, joissa ilmasto on kostea ja sumupilvet riippuvat alhaalla maan tasolla. Pasaatituulten takia alueella on pilvistä ja sateista ympäri vuoden, mikä mahdollistaa vehreän kasvillisuuden. Saavuttuamme opastuskeskukselle huomasimme autosta ulos astuessamme kostean ja sumuisen ilman konkreettisen vaikutuksen. Ilma tuntui hyvin viileältä, olihan lämpötila laskenut noin 10 astetta alhaalta merenpinnasta ylös ajaessamme.\n\nOpastuskeskukselta lähti 2–4 kilometrin reitti laakeripuumetsän halki näköalapaikalle ja takaisin. Ihailimme laakeripuita, suuria kanervapensaita ja sammalen peittämiä puiden runkoja. Näköalapaikalta näkyi upeat maisemat kohti merta, tosin pilvet hieman heikensivät näkyvyyttä. Anagan puistoon olisi ihana päästä joskus pidemmälle vaellukselle, luonto ja maisemat olivat niin upeita. Alueella olisi satoja kilometrejä merkittyjä reittejä, joita mielellään lähtisi tutkimaan kaikessa rauhassa. Retken jälkeen nautimme kahvit ja herkut pienessä kahvilassa opastuskeskuksen yhteydessä.\n\nAnagasta palasimme alas merenrantaan ja suuntasimme Santa Cruziin tutustumaan saaren pääkaupunkiin. Nautimme tapaksia ja hoidimme pieniä matkamuisto-ostoksia. Lapset viihtyivät leikkipaikalla, ja saimme kahvit ja jäätelötkin nautittua iltapäivän auringossa. Pian olikin jo kiire suunnata takaisin hotellille, jotta päivän uintikiintiö saataisiin täytettyä.',
          media: [
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '5rm69RAbPJXkLdj5Oob8Wu',
                type: 'Asset',
                createdAt: '2020-03-24T10:27:30.070Z',
                updatedAt: '2020-03-24T10:27:30.070Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                locale: 'fi-FI'
              },
              fields: {
                title: 'teneriffa-espanja-016',
                description:
                  'Anagan luonnonpuisto sijaitsee vuoristossa saaren koillisosassa.',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 167393,
                    image: {
                      width: 690,
                      height: 920
                    }
                  },
                  fileName: 'teneriffa-espanja-016.jpg',
                  contentType: 'image/jpeg'
                }
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '5Mw8Exe97MKUTLSEu5o9um',
                type: 'Asset',
                createdAt: '2020-03-24T10:28:44.724Z',
                updatedAt: '2020-03-24T10:28:44.724Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                locale: 'fi-FI'
              },
              fields: {
                title: 'teneriffa-espanja-017',
                description:
                  'Sademetsissä kanervat kasvavat korkeiksi pensaiksi asti.',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 233130,
                    image: {
                      width: 770,
                      height: 920
                    }
                  },
                  fileName: 'teneriffa-espanja-017.jpg',
                  contentType: 'image/jpeg'
                }
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '3HVjzAuSrukZPkgZf4EXxV',
                type: 'Asset',
                createdAt: '2020-03-24T10:29:45.600Z',
                updatedAt: '2020-03-24T10:29:45.600Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                locale: 'fi-FI'
              },
              fields: {
                title: 'teneriffa-espanja-018',
                description:
                  'Maisemat näköalapaikalta kohti vuoristoa ja merta olivat häikäiseviä.',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 168815,
                    image: {
                      width: 1227,
                      height: 920
                    }
                  },
                  fileName: 'teneriffa-espanja-018.jpg',
                  contentType: 'image/jpeg'
                }
              }
            }
          ]
        }
      },
      {
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'bh7k0sgo84rb'
            }
          },
          id: 'SNdXMvxjx1BapzWZVM98Q',
          type: 'Entry',
          createdAt: '2020-03-24T10:35:04.954Z',
          updatedAt: '2020-03-24T10:35:04.954Z',
          environment: {
            sys: {
              id: 'sandbox1',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: 'Link',
              linkType: 'ContentType',
              id: 'experiencePhase'
            }
          },
          locale: 'fi-FI'
        },
        fields: {
          label: 'Valassafari',
          title: 'Eviä näkyvissä!',
          mainMedia: {
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'bh7k0sgo84rb'
                }
              },
              id: '5tSvYgU1TgQ0qGWDwwh9Fm',
              type: 'Asset',
              createdAt: '2020-03-24T10:32:33.946Z',
              updatedAt: '2020-03-24T10:32:33.946Z',
              environment: {
                sys: {
                  id: 'sandbox1',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              revision: 1,
              locale: 'fi-FI'
            },
            fields: {
              title: 'teneriffa-espanja-019',
              description:
                'Valaista näkyi vain vilaus päästä ja evät veden pinnalla, mutta niiden etsiminen merestä oli jännää puuhaa!',
              file: {
                url: '//localhost:3000/static/test/dummy-image.png',
                details: {
                  size: 284622,
                  image: {
                    width: 1227,
                    height: 920
                  }
                },
                fileName: 'teneriffa-espanja-019.jpg',
                contentType: 'image/jpeg'
              }
            }
          },
          content:
            'Seuraavana päivänä suuntasimme Los Cristianoksen satamasta valas- ja delfiinisafarille. Teneriffan ja La Gomeran saarten välisissä syvänteissä asustelee pallopäävalaita ja pullonokkadelfiinejä ja niitä toivoimmekin retkellä näkevämme. Alueella on mahdollista nähdä myös muitakin valaslajeja, koska valaat vaeltavat saarten välistä vuosittain. \n\nVeneemme suuntasi satamasta määrätietoisesti kohti paikkaa, jossa valaita usein tavataan ja pienen matkanteon jälkeen havaitsimmekin valaiden eviä veden pinnan yläpuolella. Iso parvi pallopäävalaita hengitteli ulapalla ja pääsimme kohtalaisen läheltä seuraamaan valaita. Joukossa oli isompia ja muuta pieni poikanenkin. Aluksemme toteutti valaiden seurantaa vastuullisesti emmekä menneet liian lähelle häiritsemään valasparvea.\n\nValaiden ihastelun jälkeen suuntasimme kalankasvatusaltaille, jotka sijaitsevat South West Hillin näköalapaikan kohdalla meressä. Kalankasvatusaltailla oli porukka melojia, jotka näyttivät löytäneen delfiinin, ja näimmepä mekin sen hyppäävän vedestä. Lisäksi jyrkänteen seinämässä oli useita kirkkaanpunaisia taskurapuja kuivattelemassa auringon lämmössä. Retken aikana näimme myös kaksi merikilpikonnaa pikaisesti uivan veneen lähistöllä. Kilpikonnat olivat todella arkoja ja ne sukelsivatkin heti syvälle, kun vene lähestyi niitä. Retken päätyttyä takaisin satamaan, olikin aika suunnata lounaalle ja jäätelölle Los Cristianoksen rannan tuntumaan.\n\nLoppupäivä lepäiltiin hotellilla ja polskuteltiin hotellin altailla. Päivän ikimuistoisin lausahdus taisi olla kaksivuotiaan kommentti “Minä näin kalan!”, kun hän heräsi veneen saapuessa satamaan nukuttuaan koko valassafarin ajan autuaan tietämättömänä retken tapahtumista.',
          media: [
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '3FPdKGyfZvqJrct4anCSJ7',
                type: 'Asset',
                createdAt: '2020-03-24T10:33:31.569Z',
                updatedAt: '2020-03-24T10:33:31.569Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                locale: 'fi-FI'
              },
              fields: {
                title: 'teneriffa-espanja-020',
                description:
                  'Kallioseinämään oli kiivennyt rapuja nauttimaan auringosta ja linnuilla oli pesiä kallion koloissa.',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 140209,
                    image: {
                      width: 690,
                      height: 920
                    }
                  },
                  fileName: 'teneriffa-espanja-020.jpg',
                  contentType: 'image/jpeg'
                }
              }
            },
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: 'PgwSdP26mwzjuMqcEyMBA',
                type: 'Asset',
                createdAt: '2020-03-24T10:34:57.555Z',
                updatedAt: '2020-03-24T10:34:57.555Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                locale: 'fi-FI'
              },
              fields: {
                title: 'teneriffa-espanja-021',
                description:
                  'Hotellilla oli lapsille paljon tekemistä: uimista, leikkipaikkoja ja aktiviteetteja, joten he olisivat varmasti viihtyneet, vaikka kaikki päivät pelkästään hotellin alueella.',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 149352,
                    image: {
                      width: 690,
                      height: 920
                    }
                  },
                  fileName: 'teneriffa-espanja-021.jpg',
                  contentType: 'image/jpeg'
                }
              }
            }
          ]
        }
      },
      {
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'bh7k0sgo84rb'
            }
          },
          id: '6ZEJo8bUVwz8Y0gonEikig',
          type: 'Entry',
          createdAt: '2020-03-24T10:47:39.419Z',
          updatedAt: '2020-03-24T10:47:39.419Z',
          environment: {
            sys: {
              id: 'sandbox1',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: 'Link',
              linkType: 'ContentType',
              id: 'experiencePhase'
            }
          },
          locale: 'fi-FI'
        },
        fields: {
          label: 'Meson Castellano',
          title: 'Herkuttelua Playa de las Americasissa',
          mainMedia: {
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'bh7k0sgo84rb'
                }
              },
              id: '4EFPXDr2HciXPv00QtXEt',
              type: 'Asset',
              createdAt: '2020-03-24T10:36:07.834Z',
              updatedAt: '2020-03-24T10:36:07.834Z',
              environment: {
                sys: {
                  id: 'sandbox1',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              revision: 1,
              locale: 'fi-FI'
            },
            fields: {
              title: 'teneriffa-espanja-022',
              description:
                'Meson Castellanon herkullisia juustoja alkupalaksi.\n',
              file: {
                url: '//localhost:3000/static/test/dummy-image.png',
                details: {
                  size: 128678,
                  image: {
                    width: 690,
                    height: 920
                  }
                },
                fileName: 'teneriffa-espanja-022.jpg',
                contentType: 'image/jpeg'
              }
            }
          },
          content:
            'Yksi lomamatkan kohokohdista on ehdottomasti aina paikallinen ruoka ravintoloissa! Kävimmekin lähes joka ilta syömässä joko Los Cristianoksen tai Playa de las Americasin ravintoloissa. Kävelymatka hotellilta oli noin kaksi kilometriä suuntaansa, joten päivän liikuntasuoritus tuli viimeistään tässä kohtaa täyteen. Hotellilta olisi mennyt ilmainen bussikin Playaan, mutta sen aikataulut eivät oikein sopineet Suomen ajassa olleeseen rytmiimme. \n\nPaella, mojo rojo ja verde, kanarianperunat, tuore kala ja muut herkut maistuivat päivästä toiseen hyvältä. Ravintoloita löytyi jokaiseen makuun. Matkan ehdottomasti paras ravintola osui sopivasti kohdalle viimeisenä iltana. Herkuttelimme Meson Castellanossa tapasannoksilla ja saarella kasvaneella kaniinilla. Illallisen kruunasi herkulliset kakkupalat, jotka upposivat lasten suihin tyytyväisen hiljaisuuden vallitessa.',
          media: [
            {
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'bh7k0sgo84rb'
                  }
                },
                id: '4wrxTw1hmj6RkBFGQxIIro',
                type: 'Asset',
                createdAt: '2020-03-24T10:47:25.182Z',
                updatedAt: '2020-03-24T10:47:25.182Z',
                environment: {
                  sys: {
                    id: 'sandbox1',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                revision: 1,
                locale: 'fi-FI'
              },
              fields: {
                title: 'teneriffa-espanja-023',
                description:
                  'Paella merenelävillä on yksi espanjalaisen ruoan klassikko.',
                file: {
                  url: '//localhost:3000/static/test/dummy-image.png',
                  details: {
                    size: 105895,
                    image: {
                      width: 690,
                      height: 920
                    }
                  },
                  fileName: 'teneriffa-espanja-023.jpg',
                  contentType: 'image/jpeg'
                }
              }
            }
          ]
        }
      },
      {
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'bh7k0sgo84rb'
            }
          },
          id: '5EXOudCDtjF6nyserlKnL0',
          type: 'Entry',
          createdAt: '2020-03-24T10:49:24.791Z',
          updatedAt: '2020-03-24T10:49:24.791Z',
          environment: {
            sys: {
              id: 'sandbox1',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          revision: 1,
          contentType: {
            sys: {
              type: 'Link',
              linkType: 'ContentType',
              id: 'travelPhase'
            }
          },
          locale: 'fi-FI'
        },
        fields: {
          label: 'Teneriffa–Helsinki',
          title: 'Akut ladattuina kotia kohti',
          mainMedia: {
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'bh7k0sgo84rb'
                }
              },
              id: '6UH31dxm0qwIKXHiwza0Ze',
              type: 'Asset',
              createdAt: '2020-03-24T10:49:19.223Z',
              updatedAt: '2020-03-24T10:49:19.223Z',
              environment: {
                sys: {
                  id: 'sandbox1',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              revision: 1,
              locale: 'fi-FI'
            },
            fields: {
              title: 'teneriffa-espanja-024',
              description:
                'Anagan vuoristo vihreine rinteineen erottui lentokoneesta katsottuna selkeästi.',
              file: {
                url: '//localhost:3000/static/test/dummy-image.png',
                details: {
                  size: 70290,
                  image: {
                    width: 690,
                    height: 920
                  }
                },
                fileName: 'teneriffa-espanja-024.jpg',
                contentType: 'image/jpeg'
              }
            }
          },
          content:
            'Oli mukava päättää viimeinen ilta saarella herkullisiin ravintolatunnelmiin. Ajatukset suunnattiiin pikkuhiljaa taas kohti koti-Suomea ja arkea. Keho täynnä tankattua auringonvaloa, mahtavia muistoja ja upeita kokemuksia rikkaampina suuntasimme kotilennolle. Matka oli meille kaikille ensimmäinen kerta Kanarialla, ja Teneriffa vakuutti meidät monipuolisuudellaan, häikäisevillä maisemillaan ja helppoudellaan. Varmasti joskus vielä palaamme jatkamaan seikkailuamme ja tutustumme saareen lisää!'
        }
      }
    ],
    destinations: [
      {
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'bh7k0sgo84rb'
            }
          },
          id: '6P5To5150m1p8J8VrmMUJy',
          type: 'Entry',
          createdAt: '2020-02-19T13:00:24.157Z',
          updatedAt: '2020-03-25T11:01:50.928Z',
          environment: {
            sys: {
              id: 'sandbox1',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          revision: 10,
          contentType: {
            sys: {
              type: 'Link',
              linkType: 'ContentType',
              id: 'destination'
            }
          },
          locale: 'fi-FI'
        },
        fields: {
          title: 'Teneriffa',
          slug: 'teneriffa',
          mainImage: {
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'bh7k0sgo84rb'
                }
              },
              id: '2hR9ONzcrLU1xC8Wo1eoLO',
              type: 'Asset',
              createdAt: '2020-02-19T13:00:12.987Z',
              updatedAt: '2020-03-25T10:21:15.418Z',
              environment: {
                sys: {
                  id: 'sandbox1',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              revision: 2,
              locale: 'fi-FI'
            },
            fields: {
              title: 'Teneriffa',
              description: 'Teneriffa, Espanja',
              file: {
                url: '//localhost:3000/static/test/dummy-image.png',
                details: {
                  size: 18288747,
                  image: {
                    width: 5102,
                    height: 3479
                  }
                },
                fileName: 'teneriffa-espanja-025.jpg',
                contentType: 'image/jpeg'
              }
            }
          },
          country: 'Espanja',
          cityErpId: 1570,
          leadParagraph:
            'Teneriffalla voit yllättyä siitä, kuinka monta salaista sopukkaa tunnetulla saarella onkaan! Irtaannu turistimassoista ja ota tuntumaa tavalliseen elämänmenoon Tagananan kalastajakylässä. Löydä salainen ranta Teneriffan syrjäisimmästä kolkasta Punta de Tenosta, joka tunnetaan punavalkoisesta majakastaan. Patikoi komeaa Mascan vuoristokylän reittiä rotkon kautta rannalle. Kun teet baarikierrroksen La Lagunan kaupungissa turistikohteiden sijaan, löydät varmasti paikallista menoa! Autenttista kaupunkitunnelmaa voi fiilistellä Santa Cruzissa, kun taas Playa de las Americas on koko saaren keskus. Tekisikö mielesi maistaa myös kanarianperunoita eli papas arrugadas tulisella mojo-kastikkeella höystettynä?',
          description:
            'Ikuisen kevään saareksi kutsutun Teneriffan säässä ei tapahdu merkittäviä lämpötilan vaihteluja vuosikierron mukaan, siksi se onkin suosittu lomakohde ympäri vuoden. Saaren eteläosassa on yleensä hieman lämpimämpää kuin korkealla vuoristossa tai pohjoisessa, missä myös sataa enemmän.\n\nHelmi-maaliskuussa juhlittavat karnevaalit ovat Teneriffan tärkeimpiä juhlia, ja näyttävä juhlinta valtaa erityisesti pääkaupunki Santa Cruzin kadut. Kesäkuussa nautitaan klassisesta musiikista Kanariansaarten musiikkifestivaalilla ja syyskuussa kansanmusiikista Sabandeño-festivaalilla.\n\nTeneriffalla pääsee liikkumaan helposti kattavan linja-autoreitistön turvin niin isoimpien kaupunkien sisällä kuin pidempien välimatkojen päähän. Taksin saa helposti lennosta ja hinnat ovat kotimaata edullisempia. Myös autonvuokraus on varteenotettava vaihtoehto, jonka turvin matkareitin voi suunnitella parhaiten itseä miellyttäväksi.\n\nMust see -kohteet\n\n1. Nouse jaloin tai kaapelikärryllä 3 700 metrin korkeuteen Espanjan korkeimman tulivuoren Teiden huipulle tai keskity vain nauttimaan kansallispuistossa vaeltamisesta.\n\n2. Matkusta lautalla luonnonkauniille La Gomeran saarelle, jossa voit patikoida upeassa Garajonayn luonnonpuistossa. Reitin varrella voit tehdä pysähdyksiä viehättävissä pikkukylissä.\n\n3. Ui Garachicon pikkukaupungin kallioisilla uima-altailla. Meren ääressä sijaitsevat luonnonaltaat muodostuivat Trevejo-tulivuoren purkauksessa vuonna 1706.',
          trips: [],
          groups: ['couple', 'family', 'friends'],
          activities: ['escape', 'chill', 'learn'],
          lengths: ['week', 'verylong']
        }
      }
    ],
    groups: ['family'],
    activities: ['chill', 'activity'],
    lengths: ['week']
  }
};
// Cast test data to CmsMemory (test objects don't include Entry methods like toPlainObject/update)
const typedLisbonMemory = lisbonMemory as unknown as CmsMemory;
const typedTenerifeMemory = tenerifeMemory as unknown as CmsMemory;
export {
  typedTenerifeMemory as tenerifeMemory,
  typedLisbonMemory as lisbonMemory
};
